// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { DeleteCorporaByIdParam, BaseResponseVoid } from '../../types';

/**
 * deleteById
 *
 * @export
 * @tags 语料库
 * @link [DELETE] /corpora/{id}
 * @param id
 */
export function deleteCorporaById(
    options: ApiOptions<DeleteCorporaByIdParam, never> & { segments: DeleteCorporaByIdParam }
): Promise<BaseResponseVoid> {
    return request<never, DeleteCorporaByIdParam, never>('/corpora/{id}', {
        ...options,
        method: 'delete',
        __$requestCalleeName: 'deleteCorporaById',
    });
}

export const meta = [{ tags: ['语料库'], path: '/corpora/{id}', method: 'delete' }];
